'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';
import AppLayout from '../../../layouts/AppLayout/AppLayout';
import { client } from '../../../utils/trpc';
import ProfileHistoryItem from '../../profile/ProfileHistoryItem';
const ProfileHistory = () => {
  const $ = _c(26);
  const params = useParams();
  const username = params?.username;
  let t0;
  let t1;
  if ($[0] !== username) {
    t0 = ["history", "profile", username];
    t1 = () => unwrapFromResult(client.users.history.query({
      username
    }, {
      context: {
        silenceErrors: true
      }
    }));
    $[0] = username;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = Boolean(username);
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    isError,
    isLoading,
    data
  } = useQuery(t3);
  let t4;
  if ($[7] !== isLoading) {
    t4 = isLoading && <p className="text-center">Loading profile history...</p>;
    $[7] = isLoading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== data || $[10] !== isLoading) {
    t5 = !isLoading && data?.current && <ProfileHistoryItem data={{
      ...data.current,
      date: "current"
    }} />;
    $[9] = data;
    $[10] = isLoading;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== data?.history) {
    t6 = data?.history.map(_temp);
    $[12] = data?.history;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== data || $[15] !== isLoading) {
    t7 = !isLoading && data?.current && data?.history?.length === 0 && <p className="text-center">@{data.current.username} hasn't edited their profile.</p>;
    $[14] = data;
    $[15] = isLoading;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isError || $[18] !== username) {
    t8 = isError && <p className="text-center text-destructive">You cannot view @{username}'s profile history at the moment.</p>;
    $[17] = isError;
    $[18] = username;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <AppLayout><div>{t4}{t5}{t6}{t7}{t8}</div></AppLayout>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
export default ProfileHistory;
function _temp(item, index) {
  return <ProfileHistoryItem key={index} data={item} />;
}